import React from 'react';
import { DarkBackground } from 'scy/Background';
import { WideContainer, NarrowContainer } from 'scy/layouts';
import {
  Hero,
  Title,
  SmallUppercase,
  H3,
  H2Alt,
  Paragraph,
  AccentBody
} from 'scy/text';
import DollarSign from 'images/icons/dollar-sign.svg?react-svg';
import RedoMarker from 'images/icons/redo-marker.svg?react-svg';
import Bodega from 'images/icons/bodega.svg?react-svg';
import { pageContainer, borderBox, textCenter } from 'scy/utils.mod.scss';
import styles from './styles.mod.scss';
import { tablet_flex } from 'scy/display.mod.scss';
import { spaceBetween } from 'scy/flex.mod.scss';
import {
  ctaSection,
  ctaIcon,
  ctaTitle,
  ctaCaption
} from '../gifting/styles.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function BecomeARetailer() {
  return (
    <div className={`${pageContainer} ${borderBox} ${textCenter}`}>
      <DarkBackground className={styles.background}>
        <Hero className={styles.hero}>Partner with Saucey</Hero>
      </DarkBackground>

      <WideContainer>
        <Title responsive tag="h2">
          Use the Saucey platform
        </Title>
        <SmallUppercase tag="h3" className={styles.subtitle}>
          To drive real revenue without increasing your costs
        </SmallUppercase>

        <div className={`${tablet_flex} ${spaceBetween}`}>
          <section className={ctaSection}>
            <AccentBody className={ctaIcon}>
              <DollarSign />
            </AccentBody>
            <H3 className={ctaTitle}>Start selling online</H3>
            <Paragraph className={ctaCaption}>
              Saucey is the fastest growing online platform for retailers to
              start selling their inventory to new customers using ecommerce.
            </Paragraph>
          </section>

          <section className={ctaSection}>
            <AccentBody className={ctaIcon}>
              <RedoMarker />
            </AccentBody>
            <H3 className={ctaTitle}>Gain customers & insights</H3>
            <Paragraph className={ctaCaption}>
              Put your entire store’s inventory into the pocket of every
              customer in town. Expand your reach, and gain insights from new
              customers.
            </Paragraph>
          </section>

          <section className={ctaSection}>
            <AccentBody className={ctaIcon}>
              <Bodega />
            </AccentBody>
            <H3 className={ctaTitle}>Grow your business</H3>
            <Paragraph className={ctaCaption}>
              There’s over $105 billion of alcohol sold at retail every year in
              the U.S. Grow your business with Saucey, the fastest growing
              online partner.
            </Paragraph>
          </section>
        </div>
      </WideContainer>

      <NarrowContainer>
        <H2Alt marginClass={margin.md}>Get in touch with us today</H2Alt>
        <Paragraph className={margin.md}>
          Fill out the form below and a Saucey representative will be in touch
          with you soon. Thank you for considering Saucey for your business!
        </Paragraph>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSdiw79F5kJToNqFeOtih4gYpT68-73BGRLqcl0ftTfAs2A5sg/viewform?embedded=true"
          width="95%"
          height="1752"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
        >
          Loading…
        </iframe>
      </NarrowContainer>
    </div>
  );
}
